import script from "./OrderTableHead.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderTableHead.vue?vue&type=script&lang=ts&setup=true"

import "./OrderTableHead.vue?vue&type=style&index=0&id=3b1565f9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b1565f9"]])

export default __exports__